module.exports = __WEBPACK_EXTERNAL_MODULE__rocket_chat_fuselage_tokens_typography_json__;